const properties = {
    status: "fulfilled",
    "properties": [
        {
            "id": 1,
            "name": "Comfort Stay Paying Guest",
            "position": "Real Estate Developer",
            "shortName": "Comfort Stay PG",
            "tags": "Preferred for students",
            "area": "1800 sq.ft",
            "price": 6000,
            "rating": "4.9",
            "agent": "John Smith",

            "category": "Residential",
            "isTopRated": true,
            "isFurnished:": "Furnished",
            "room_type": "Flat",
            "popular": true,
            "isNew": false,
            "isSpecial": true,
            "status": 'shortlisted',
            "agentImage": "https://george-fx.github.io/nuton/author.png",
            "preview_90x90": require('../assets/nestfin/p8.jpg'),
            "previewImages": [
                require('../assets/nestfin/p1.jpg'),
                require('../assets/nestfin/p2.jpg'),
                require('../assets/nestfin/p3.jpg'),
                require('../assets/nestfin/p4.jpg'),
            ],
            "innerPreview": "https://george-fx.github.io/nuton/inner_image.png",
            "bigPreview": "https://george-fx.github.io/nuton/courses/01-big.png",
            "threeDPreview": require('../assets/nestfin/3d3.png'),
            // "video": require('../assets/nestfin/v1.mp4'),
            "description": "A luxurious 3-bedroom apartment located in the heart of Downtown with stunning views and premium amenities.",
            "aboutAgent": "John Smith has been in the real estate business for over 15 years, specializing in high-end properties and luxury apartments."
        },
        {
            "id": 2,
            "name": "Cozy Nest Paying Guest Accommodation",
            "position": "Real Estate Developer",
            "shortName": "Cozy Nest PG",
            "tags": "Recommended",
            "area": "1200 sq.ft",
            "price": 12000,
            "rating": "4.8",
            "agent": "Sarah Lee",
            "category": "Commercial",
            "isTopRated": true,
            "isFurnished:": "Furnished",
            "room_type": "Flat",
            "popular": false,
            "isNew": true,
            "isSpecial": false,
            "status": "shortlisted",
            "agentImage": "https://george-fx.github.io/nuton/author.png",
            "preview_90x90": require('../assets/nestfin/p2.jpg')
            ,
            "previewImages": [
                require('../assets/nestfin/p1.jpg'),
                require('../assets/nestfin/p3.jpg'),
                require('../assets/nestfin/p4.jpg'),
                require('../assets/nestfin/p2.jpg'),
            ],
            "innerPreview": "https://george-fx.github.io/nuton/inner_image.png",
            "bigPreview": "https://george-fx.github.io/nuton/courses/02-big.png",
            "threeDPreview": require('../assets/nestfin/3d3.png'),
            // "video": require('../assets/nestfin/v2.mp4'),
            "description": "A modern and stylish loft apartment located in the trendy Soho district, perfect for professionals and creatives.",
            "aboutAgent": "Sarah Lee is a real estate agent with 10 years of experience, focusing on commercial properties in New York."
        },
        {
            "id": 3,
            "name": "Urban Haven Paying Guest Residence",
            "position": "Real Estate Developer",
            "shortName": "Urban Haven PG",
            "tags": "Comfortable",

            "area": "4000 sq.ft",
            "price": 6000,
            "rating": "5.0",
            "agent": "Michael Davis",
            "category": "Luxury",
            "isTopRated": true,
            "isFurnished:": "Furnished",
            "room_type": "Flat",
            "popular": true,
            "isNew": false,
            "isSpecial": true,
            "status": 'visit',
            "agentImage": "https://george-fx.github.io/nuton/author.png",
            "preview_90x90": require('../assets/nestfin/p9.jpg'),
            "innerPreview": "https://george-fx.github.io/nuton/inner_image.png",
            "bigPreview": "https://george-fx.github.io/nuton/courses/03-big.png",
            "threeDPreview": require('../assets/nestfin/3d3.png'),
            // "video": require('../assets/nestfin/v3.mp4'),
            "description": "An exquisite beachfront villa in Malibu with panoramic ocean views and private access to the beach.",
            "aboutAgent": "Michael Davis specializes in luxury beachfront properties and has been working with high-net-worth clients for over 20 years."
        },
        {
            "id": 4,
            "name": "Elite Living Paying Guest Facility",
            "position": "Real Estate Developer",
            "shortName": "Elite Living PG",
            "tags": "Preferred for students",
            "area": "950 sq.ft",
            "price": 10000,
            "rating": "4.5",
            "agent": "Emily White",
            "category": "Residential",
            "isTopRated": false,
            "popular": true,
            "isNew": false,
            "isSpecial": false,
            "status": 'booked',
            "agentImage": "https://george-fx.github.io/nuton/author.png",
            "preview_90x90": require('../assets/nestfin/p4.jpg'),
            "previewImages": [
                require('../assets/nestfin/p1.jpg'),
                require('../assets/nestfin/p2.jpg'),
                require('../assets/nestfin/p3.jpg'),
                require('../assets/nestfin/p4.jpg'),
            ],

            "innerPreview": "https://george-fx.github.io/nuton/inner_image.png",
            "bigPreview": "https://george-fx.github.io/nuton/courses/04-big.png",
            "threeDPreview": require('../assets/nestfin/3d3.png'),
            // "video": require('../assets/nestfin/v4.mp4'),
            "description": "A cozy and affordable cottage in the countryside, ideal for those seeking peace and tranquility away from city life.",
            "aboutAgent": "Emily White is an expert in selling residential properties in rural areas, with a focus on charming and affordable cottages."
        },
        {
            "id": 5,
            "name": "Stylish 1 BHK Apartments for Rent",
            "position": "Real Estate Developer",
            "shortName": "Stylish 1 BHK Apartments for Rent",
            "tags": "Preferred for students",
            "area": "2500 sq.ft",
            "price": 5000,
            "rating": "5.0",
            "agent": "Chris Johnson",
            "category": "Luxury",
            "isTopRated": true,
            "isFurnished:": "Furnished",
            "room_type": "Flat",
            "popular": true,
            "isNew": true,
            "isSpecial": true,
            "status": 'booked',
            "agentImage": "https://george-fx.github.io/nuton/author.png",
            "preview_90x90": require('../assets/nestfin/p5.jpg'),
            "innerPreview": "https://george-fx.github.io/nuton/inner_image.png",
            "bigPreview": "https://george-fx.github.io/nuton/courses/05-big.png",
            "threeDPreview": require('../assets/nestfin/3d3.png'),
            // "video": require('../assets/nestfin/v5.mp4'),
            "description": "A luxurious penthouse with stunning city views, offering a modern living experience in the heart of the city center.",
            "aboutAgent": "Chris Johnson is a leading agent in luxury real estate and specializes in high-end penthouses and city-center properties."
        },
        {
            "id": 6,
            "name": "Contemporary Family Home",
            "position": "Real Estate Developer",
            "shortName": "Family Home",
            "area": "2200 sq.ft",
            "price": 4000,
            "rating": "4.8",
            "agent": "Anna Harris",
            "category": "Residential",
            "isTopRated": true,
            "isFurnished:": "Furnished",
            "room_type": "Flat",
            "popular": true,
            "isNew": false,
            "isSpecial": true,
            "status": 'booked',
            "agentImage": "https://george-fx.github.io/nuton/author.png",
            "preview_90x90": require('../assets/nestfin/p6.jpg'),
            "innerPreview": "https://george-fx.github.io/nuton/inner_image.png",
            "bigPreview": "https://george-fx.github.io/nuton/courses/01-big.png",
            "threeDPreview": require('../assets/nestfin/3d3.png'),
            // "video": require('../assets/nestfin/v6.mp4'),
            "description": "A spacious and modern family home with four bedrooms, a large backyard, and a cozy living room for family gatherings.",
            "aboutAgent": "Anna Harris has been in real estate for over 12 years, with expertise in selling family homes in suburban areas."
        },
        {
            id: 7,
            name: "Greenfield Cozy PG",
            position: "Real Estate Developer",
            shortName: "Greenfield PG",
            tags: "Family Friendly",
            area: "1300 sq.ft",
            price: 7000,
            rating: "4.7",
            agent: "Lisa Brown",
            category: "Residential",
            isTopRated: false,
            isFurnished: "Semi-Furnished",
            room_type: "Flat",
            popular: false,
            isNew: true,
            isSpecial: false,
            status: 'available',
            agentImage: "https://george-fx.github.io/nuton/author.png",  // same agent image
            preview_90x90: require('../assets/nestfin/p1.jpg'),  // reused image 1
            previewImages: [
                require('../assets/nestfin/p2.jpg'),
                require('../assets/nestfin/p3.jpg'),
                require('../assets/nestfin/p4.jpg'),
            ],
            innerPreview: "https://george-fx.github.io/nuton/inner_image.png",
            bigPreview: "https://george-fx.github.io/nuton/courses/01-big.png",
            threeDPreview: require('../assets/nestfin/3d3.png'),  // reused 3d image
            // video: require('../assets/nestfin/v1.mp4'),   
            description: "A warm and inviting PG accommodation suitable for small families, featuring lush green surroundings and modern amenities.",
            aboutAgent: "Lisa Brown has been dedicated to helping families find cozy and affordable accommodations for over 8 years."
        },
        {
            id: 8,
            name: "Downtown Executive PG",
            position: "Real Estate Developer",
            shortName: "Downtown Executive",
            tags: "Premium Location",
            area: "1600 sq.ft",
            price: 15000,
            rating: "4.9",
            agent: "David Green",
            category: "Commercial",
            isTopRated: true,
            isFurnished: "Fully Furnished",
            room_type: "Flat",
            popular: true,
            isNew: false,
            isSpecial: true,
            status: 'booked',
            agentImage: "https://george-fx.github.io/nuton/author.png",
            preview_90x90: require('../assets/nestfin/p2.jpg'),  // reused image 2
            previewImages: [
                require('../assets/nestfin/p1.jpg'),
                require('../assets/nestfin/p3.jpg'),
                require('../assets/nestfin/p4.jpg'),
            ],
            innerPreview: "https://george-fx.github.io/nuton/inner_image.png",
            bigPreview: "https://george-fx.github.io/nuton/courses/02-big.png",
            threeDPreview: require('../assets/nestfin/3d3.png'),
            // video: require('../assets/nestfin/v2.mp4'),
            description: "A fully furnished executive PG located downtown, close to business hubs and entertainment centers.",
            aboutAgent: "David Green is known for managing premium commercial properties in high-demand urban areas."
        },
        {
            id: 9,
            name: "Seaside Serenity PG",
            position: "Real Estate Developer",
            shortName: "Seaside Serenity",
            tags: "Ocean View",
            area: "2000 sq.ft",
            price: 13000,
            rating: "5.0",
            agent: "Olivia White",
            category: "Luxury",
            isTopRated: true,
            isFurnished: "Fully Furnished",
            room_type: "Villa",
            popular: true,
            isNew: true,
            isSpecial: true,
            status: 'visit',
            agentImage: "https://george-fx.github.io/nuton/author.png",
            preview_90x90: require('../assets/nestfin/p3.jpg'),  // reused image 3
            previewImages: [
                require('../assets/nestfin/p2.jpg'),
                require('../assets/nestfin/p1.jpg'),
                require('../assets/nestfin/p4.jpg'),
            ],
            innerPreview: "https://george-fx.github.io/nuton/inner_image.png",
            bigPreview: "https://george-fx.github.io/nuton/courses/03-big.png",
            threeDPreview: require('../assets/nestfin/3d3.png'),
            // video: require('../assets/nestfin/v3.mp4'),
            description: "A stunning beachfront villa offering panoramic ocean views, perfect for those seeking luxury and tranquility.",
            aboutAgent: "Olivia White specializes in luxury beachfront properties and provides premium services to elite clients."
        },
        {
            id: 10,
            name: "Metro Central PG",
            position: "Real Estate Developer",
            shortName: "Metro Central",
            tags: "Near Metro Station",
            area: "1400 sq.ft",
            price: 8000,
            rating: "4.6",
            agent: "Mark Thompson",
            category: "Residential",
            isTopRated: false,
            isFurnished: "Semi-Furnished",
            room_type: "Flat",
            popular: false,
            isNew: false,
            isSpecial: false,
            status: 'available',
            agentImage: "https://george-fx.github.io/nuton/author.png",
            preview_90x90: require('../assets/nestfin/p4.jpg'),  // reused image 4
            previewImages: [
                require('../assets/nestfin/p1.jpg'),
                require('../assets/nestfin/p2.jpg'),
                require('../assets/nestfin/p3.jpg'),
            ],
            innerPreview: "https://george-fx.github.io/nuton/inner_image.png",
            bigPreview: "https://george-fx.github.io/nuton/courses/04-big.png",
            threeDPreview: require('../assets/nestfin/3d3.png'),
            // video: require('../assets/nestfin/v4.mp4'),
            description: "Conveniently located PG near the metro station with easy access to public transportation and city amenities.",
            aboutAgent: "Mark Thompson has extensive experience in residential properties near urban transit hubs."
        },
    ]
}

export default properties;
